// Copyright (c) 2020 Verimatrix, Inc.  All Rights Reserved.

import iptv from './IPTV.png'
import multiDrm from './MultiDRM.png'
import omi from './OMI.png'
import ott from './OTT.png'

export const iptvImg = iptv
export const multiDrmImg = multiDrm
export const omiImg = omi
export const ottImg = ott
